import { getDefaultDisplayMode } from "../../../components-ui/resizable-sidebar";
import { eMode } from "../../../content/enum";
import { IMucThuTinChiActionTypes } from "../../action-types/muc-thu/IMucThuTinChiActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMucThuTinChiReducer } from "../../reducer-model/muc-thu/IMucThuTinChiReducer";

const iniState: IMucThuTinChiReducer = {
  statusSinhVien: eReducerStatusBase.is_not_initialization,
  status: eReducerStatusBase.is_not_initialization,
  sinhViens: [],
  displayMode: getDefaultDisplayMode(),
  loaiThuChiId: 0,
  kyDangKyId: 0,
  mucThuKhacs: [],
  doiTuongIds: [],
  trangThaiHocs: [0],
  trangThaiTongHop: "all",
  tinhChatHoc: -1,
  sinhViensViewing: undefined,
  tab: "all",
  locTrangThaiRut: "all",
  ltnTree: [],
  ltnStatusTree: eReducerStatusBase.is_not_initialization,
  ltnSelected: undefined,
  ltnSinhViens: [],
  ltnStatusSv: eReducerStatusBase.is_not_initialization,
  ltnSelectedSvIds: [],
  ltnFocusedCell: undefined,
  ltnIsShowGanModal: false,
  ltnIsShowProcessing: false,
  ltnProcessId: undefined,
};
export const mucThuTinChiReducer = (
  state: IMucThuTinChiReducer = iniState,
  action: IMucThuTinChiActionTypes,
): IMucThuTinChiReducer => {
  switch (action.type) {
    case "MUC_THU_TIN_CHI_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        statusSinhVien: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_TIN_CHI_LOAD_HOCSINH_START":
      return {
        ...state,
        statusSinhVien: eReducerStatusBase.is_loading,
      };
    case "MUC_THU_TIN_CHI_LOAD_HOCSINH_SUCCESS":
      return {
        ...state,
        statusSinhVien: eReducerStatusBase.is_completed,
        status: eReducerStatusBase.is_need_reload,
        sinhViens: action.payload,
      };
    case "MUC_THU_TIN_CHI_LOAD_HOCSINH_ERRR":
      return {
        ...state,
        statusSinhVien: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_TIN_CHI_CHANGE_LOAI_THU_CHI":
      return {
        ...state,
        loaiThuChiId: action.payload,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_KY_DANG_KY":
      return {
        ...state,
        kyDangKyId: action.payload,
        statusSinhVien: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_TIN_CHI_CALCULATE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        calculate: {
          isShowModal: true,
          sinhVienLopTinChiSoTiens: [],
        },
      };
    case "MUC_THU_TIN_CHI_CALCULATE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        calculate: {
          ...state.calculate,
          sinhVienLopTinChiSoTiens: action.payload.sinhViens,
          cacheKey: action.payload.cache_key,
        },
      };
    case "MUC_THU_TIN_CHI_CALCULATE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        calculate: {
          ...state.calculate,
          sinhVienLopTinChiSoTiens: [],
        },
      };
    case "MUC_THU_TIN_CHI_UPDATE_CALCULATE_STATE": {
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        calculate: {
          ...state.calculate,
          ...action.payload,
        },
      };
    }
    case "MUC_THU_TIN_CHI_SAVE_CALCULATE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_TIN_CHI_SAVE_CALCULATE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        calculate: undefined,
      };
    case "MUC_THU_TIN_CHI_SAVE_CALCULATE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_TIN_CHI_LOAD_MUCTHUKHAC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_THU_TIN_CHI_LOAD_MUCTHUKHAC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuKhacs: action.payload,
      };
    case "MUC_THU_TIN_CHI_LOAD_MUCTHUKHAC_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucThuKhacs: [],
      };
    case "MUC_THU_TIN_CHI_CHANGE_TRANG_THAI_HOC":
      return {
        ...state,
        trangThaiHocs: action.payload,
        statusSinhVien: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_TRANG_TONG_HOP":
      return {
        ...state,
        trangThaiTongHop: action.payload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_TINH_CHAT_HOC":
      return {
        ...state,
        tinhChatHoc: action.payload,
      };
    case "MUC_THU_TIN_CHI_SHOWHIDE_VIEW_LOPTINCHIS":
      return {
        ...state,
        sinhViensViewing: action.payload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_DOI_TUONG":
      return {
        ...state,
        doiTuongIds: action.payload,
        statusSinhVien: eReducerStatusBase.is_need_reload,
      };
    case "MUC_THU_TIN_CHI_CHANGE_LOC_TRANG_THAI_RUT":
      return { ...state, locTrangThaiRut: action.payload };
    case "MUC_THU_TIN_CHI_CHANGE_TAB_PAGE":
      return {
        ...state,
        tab: action.payload,
        statusSinhVien: eReducerStatusBase.is_need_reload,
      };

    // ===== Lớp tự nguyện (LTN) =====
    case "MUC_THU_TIN_CHI_LOAD_LTN_TREE_START":
      return {
        ...state,
        ltnStatusTree: eReducerStatusBase.is_loading,
        ltnSelected: undefined,
        ltnSinhViens: [],
        ltnSelectedSvIds: [],
      };
    case "MUC_THU_TIN_CHI_LOAD_LTN_TREE_SUCCESS":
      return {
        ...state,
        ltnStatusTree: eReducerStatusBase.is_completed,
        ltnTree: action.payload,
      };
    case "MUC_THU_TIN_CHI_LOAD_LTN_TREE_ERRR":
      return {
        ...state,
        ltnStatusTree: eReducerStatusBase.is_completed,
        ltnTree: [],
      };
    case "MUC_THU_TIN_CHI_SELECT_LTN_LOP_TC":
      return {
        ...state,
        ltnSelected: action.payload,
        ltnSelectedSvIds: [],
        ltnStatusSv: action.payload
          ? eReducerStatusBase.is_need_reload
          : eReducerStatusBase.is_not_initialization,
        ltnSinhViens: action.payload ? state.ltnSinhViens : [],
      };
    case "MUC_THU_TIN_CHI_LOAD_LTN_SINHVIEN_START":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_loading,
      };
    case "MUC_THU_TIN_CHI_LOAD_LTN_SINHVIEN_SUCCESS":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_completed,
        ltnSinhViens: action.payload,
      };
    case "MUC_THU_TIN_CHI_LOAD_LTN_SINHVIEN_ERRR":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_completed,
        ltnSinhViens: [],
      };
    case "MUC_THU_TIN_CHI_LTN_SELECT_SV_IDS":
      return {
        ...state,
        ltnSelectedSvIds: action.payload,
      };
    case "MUC_THU_TIN_CHI_LTN_CHANGE_FOCUSED_CELL":
      return {
        ...state,
        ltnFocusedCell: action.payload,
      };
    case "MUC_THU_TIN_CHI_LTN_SHOWHIDE_GAN_MODAL":
      return {
        ...state,
        ltnIsShowGanModal: action.payload,
      };
    case "MUC_THU_TIN_CHI_GAN_MUC_THU_START":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_saving,
      };
    case "MUC_THU_TIN_CHI_GAN_MUC_THU_SUCCESS":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_need_reload,
        ltnIsShowGanModal: false,
        ltnSelectedSvIds: [],
      };
    case "MUC_THU_TIN_CHI_GAN_MUC_THU_ERRR":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_TIN_CHI_DUYET_LTN_START":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_saving,
        ltnIsShowProcessing: true,
        ltnProcessId: action.payload.process_id,
      };
    case "MUC_THU_TIN_CHI_DUYET_LTN_SUCCESS":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_need_reload,
        ltnSelectedSvIds: [],
      };
    case "MUC_THU_TIN_CHI_DUYET_LTN_ERRR":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_TIN_CHI_HUYDUYET_LTN_START":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_saving,
        ltnIsShowProcessing: true,
        ltnProcessId: action.payload.process_id,
      };
    case "MUC_THU_TIN_CHI_HUYDUYET_LTN_SUCCESS":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_need_reload,
        ltnSelectedSvIds: [],
      };
    case "MUC_THU_TIN_CHI_HUYDUYET_LTN_ERRR":
      return {
        ...state,
        ltnStatusSv: eReducerStatusBase.is_completed,
      };
    case "MUC_THU_TIN_CHI_LTN_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        ltnIsShowProcessing: false,
        ltnProcessId: undefined,
      };
    default:
      return state;
  }
};
